import { render, staticRenderFns } from "./FAQDrop.vue?vue&type=template&id=ec44dea0"
import script from "./FAQDrop.vue?vue&type=script&lang=js"
export * from "./FAQDrop.vue?vue&type=script&lang=js"
import style0 from "./FAQDrop.vue?vue&type=style&index=0&id=ec44dea0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports